/* eslint-disable */
import { FETCH_TICKETS_FAILED, FETCH_TICKETS_REQUEST, FETCH_TICKETS_SUCCESS } from './actionCreator';

const initialState = {
  tickets:    [],
  columnOptions: {},
  pagination: {
    totalItems:  0,
    totalPages:  1,
    currentPage: 1,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPrevPage: false,
  },
  loading: false,
  error:   null,
};

const ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TICKETS_REQUEST:
      return { ...state, columnOptions: {}, loading: true, error: null };

    case FETCH_TICKETS_SUCCESS:
      return {
        ...state,
        loading:    false,
        error:      null,
        tickets:    action.payload.data,      
        pagination: action.payload.pagination,
        columnOptions: action.payload.columnOptions || {},
      };

    case FETCH_TICKETS_FAILED:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default ticketReducer;